export default "__VITE_ASSET__DIM3H6rB__"